import { development } from './development';
import { production } from './production';

export const STAGE = {
  LOCAL: 'local',
  DEV: 'dev',
  TEST: 'test',
  PROD: 'prod',
};

const getConfigByStageValue = (stage) => {
  switch (stage) {
    case STAGE.LOCAL:
    case STAGE.DEV:
    case STAGE.TEST:
      return { ...development };
    case STAGE.PROD:
    default:
      return { ...production };
  }
};

const getEnvVariables = () => {
  const {
    NODE_ENV,

    ANALYTICS_ENV_ID,
    NEW_RELIC_ENV_ID,
    MONETATE_ENV_URL,
    NEW_RELIC_AGENT_ID,
    NEW_RELIC_APPLICATION_ID,
    BROWSE_HOST,
    REACT_APP_STAGE,
    REACT_APP_BROWSE_HOST,
    REACT_APP_HOST,
    REACT_APP_PROXY_HOST,
    REACT_APP_API_HOST,
    REACT_APP_MY_ACCOUNT_HOST,
    REACT_APP_SIGN_IN_HOST,
    REACT_APP_AUTH0_ENABLED,
    REACT_APP_FEATURES_APP_ENV,
    REACT_APP_PHONE_CONSULTATION_APPOINTMENT_ID,
    REACT_APP_WOMENS_STYLIST_APPOINTMENT_ID,
    REACT_APP_WOMENS_STYLIST_WARDROBE_APPOINTMENT_ID,
    REACT_APP_NURSERY_45_MIN_INSTORE_APPOINTMENT_ID,
  } = process.env;
  const apiWithOverriddenAppHost = REACT_APP_API_HOST === undefined ? `${REACT_APP_HOST}:8888` : REACT_APP_API_HOST;
  const apiWithDefaultAppHost = REACT_APP_API_HOST === undefined ? 'http://localhost:8888' : REACT_APP_API_HOST;

  return ({
    NODE_ENV,

    ANALYTICS_ENV_ID: ANALYTICS_ENV_ID || 'onejldev',
    NEW_RELIC_ENV_ID: NEW_RELIC_ENV_ID || 'disabled',
    NEW_RELIC_AGENT_ID: NEW_RELIC_AGENT_ID || 'disabled',
    NEW_RELIC_APPLICATION_ID: NEW_RELIC_APPLICATION_ID || 'disabled',
    MONETATE_ENV_URL: MONETATE_ENV_URL || '2/a-76ca7dd3/p/johnlewis.com',
    APP_ID: '423efe90-9e45-42ae-a622-3b7421b8546d',
    BROWSE_HOST: BROWSE_HOST || 'www.johnlewis.com',
    REACT_APP_STAGE: REACT_APP_STAGE || STAGE.PROD,
    REACT_APP_BROWSE_HOST: REACT_APP_BROWSE_HOST || 'https://www.johnlewis.com',
    REACT_APP_HOST,
    REACT_APP_PROXY_HOST: REACT_APP_HOST ? (REACT_APP_PROXY_HOST || `${REACT_APP_HOST}:3005`) : REACT_APP_PROXY_HOST,
    REACT_APP_API_HOST: REACT_APP_HOST ? apiWithOverriddenAppHost : apiWithDefaultAppHost,
    REACT_APP_MY_ACCOUNT_HOST: REACT_APP_MY_ACCOUNT_HOST || (REACT_APP_HOST ? `${REACT_APP_HOST}:9090` : 'https://stubs-downstream-api.appointments.flex.jl-digital.net'),
    REACT_APP_SIGN_IN_HOST: REACT_APP_SIGN_IN_HOST || (REACT_APP_HOST ? `${REACT_APP_HOST}:9090` : 'http://localhost:9090'),
    REACT_APP_AUTH0_ENABLED: REACT_APP_AUTH0_ENABLED || 'false',
    REACT_APP_FEATURES_APP_ENV: REACT_APP_FEATURES_APP_ENV || 'stubs',
    REACT_APP_PHONE_CONSULTATION_APPOINTMENT_ID,
    REACT_APP_WOMENS_STYLIST_APPOINTMENT_ID,
    REACT_APP_WOMENS_STYLIST_WARDROBE_APPOINTMENT_ID,
    REACT_APP_NURSERY_45_MIN_INSTORE_APPOINTMENT_ID
  });
};

export const ENV_VARS = getEnvVariables();

export const isEnvDevelopment =
  ENV_VARS.REACT_APP_STAGE === STAGE.LOCAL || ENV_VARS.REACT_APP_STAGE === STAGE.DEV;

export const config = getConfigByStageValue(ENV_VARS.REACT_APP_STAGE);
